import { Box, FormHelperText, FormLabel, Stack } from '@mui/material';
import { Control, useController } from 'react-hook-form';
import { ErrorOutlineRounded } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers';
import { useAssortmentTFunction } from '@retail/monitoring-assortment/i18n';
import { useMemo } from 'react';
import { ExpireItemsSchema } from './expireItemsSchema';

interface Props {
  control: Control<ExpireItemsSchema>;
}

export function DeletionFromDateForm({ control }: Props) {
  const t = useAssortmentTFunction();

  const today = useMemo(() => new Date(), []);

  const fromDateController = useController({ name: 'fromDate', control });

  return (
    <Box display="flex" alignItems="center">
      <FormLabel error={!!fromDateController.fieldState.error} sx={{ width: 220, fontWeight: 600 }}>
        {t('assortment.deleteItems.form.removalDate')}
      </FormLabel>

      <Stack gap={1} overflow="hidden">
        {/* Shows today until the user picks a date — the field itself stays null so no date is sent. */}
        <DatePicker
          {...fromDateController.field}
          value={fromDateController.field.value ?? today}
          minDate={today}
          format="dd/MM/yyyy"
          slotProps={{
            textField: { sx: { width: 192 } },
          }}
        />

        {!!fromDateController.fieldState.error && (
          <Stack direction="row" spacing={1} flexWrap="nowrap" alignItems="center">
            <ErrorOutlineRounded color="warning" fontSize="small" />
            <FormHelperText sx={{ color: 'warning.main' }}>
              {fromDateController.fieldState.error.message}
            </FormHelperText>
          </Stack>
        )}
      </Stack>
    </Box>
  );
}
